import type { ClientListItem } from 'src/admin/users/types';
import { ClientSearchModal } from 'src/clients/components/ClientSearchModal';
import { useAddEventParticipant } from 'src/meetings/hooks/useAddEventParticipant';
import { showSuccess } from 'src/toasts/toasts';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

type Props = {
  opened: boolean;
  onClose: () => void;
  eventId: string;
  onClientAdded: () => Promise<void>;
};

export function AddExistingClientModal({ opened, onClose, eventId, onClientAdded }: Props) {
  const { mutateAsync: addParticipant, isPending } = useAddEventParticipant(eventId);

  async function handleToggle(client: ClientListItem) {
    try {
      await addParticipant({ clientId: client.id });
      showSuccess('Client linked to meeting');
      await onClientAdded();
      onClose();
    } catch (error) {
      notifyAndLogError(
        'Failed to link client',
        'Could not link the client to this meeting. Please try again.',
        error,
      );
    }
  }

  return (
    <ClientSearchModal
      opened={opened}
      onClose={onClose}
      onToggle={handleToggle}
      loading={isPending}
    />
  );
}
